/* eslint-disable no-new */

import React from "react";
import { I18n } from "i18n-js";
import * as locales from "../../locales.json";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";

interface HovercardProps {
  user: any;
  handleHideHovercard: any;
  poppify: any;
}

export default class Hovercard extends React.Component<HovercardProps, any> {
  componentDidMount() {
    this.props.poppify();
  }

  componentDidUpdate() {
    this.props.poppify();
  }

  render() {
    return (
      <div className="hovercard-container">
        <div className="hovercard">
          <div onClick={this.props.handleHideHovercard} className="close" />
          <div className="user">
            <div className="basic-info">
              {this.renderProfilePic()}
              {this.renderName()}
            </div>
            <hr />
            <ul className="details">
              {this.renderLocation()}
              {this.renderRecentlyGaveTo()}
              {this.renderTeamRole()}
              {this.renderCurrentAchievements()}
            </ul>
          </div>
          {this.renderGiveButton()}
        </div>
        <div className="arrow outer" />
        <div className="arrow inner" />
      </div>
    );
  }

  renderProfilePic = () => {
    return (
      <div className="profile-pic">
        <a href={this.props.user.profilePageLink}>
          <img alt="profile-pic" src={this.props.user.profilePic} />
        </a>
      </div>
    );
  };

  renderName = () => {
    return (
      <div className="name">
        <h4 className="display-name">
          <a href={this.props.user.profilePageLink}>{this.props.user.name}</a>
        </h4>
        <div className="username">
          <a href={this.props.user.profilePageLink}>
            @{this.props.user.username}
          </a>
        </div>
      </div>
    );
  };

  renderLocation = () => {
    if (this.props.user.location) {
      return (
        <li>
          <i className="fa fa-fw fa-map-pin" />
          {this.props.user.location}
        </li>
      );
    }

    return null;
  };

  renderRecentlyGaveTo = () => {
    if (this.props.user.lastBonusGiven.url) {
      return (
        <li>
          <i className="fa fa-fw fa-heart" />
          {i18n.translate("hovercard.recently_gave_to")}
          &nbsp;
          <a href={this.props.user.lastBonusGiven.url}>
            {i18n.translate("hovercard.bonus_receivers", {
              names: this.props.user.lastBonusGiven.receiverNames,
            })}
          </a>
        </li>
      );
    }

    return null;
  };

  renderTeamRole = () => {
    if (this.props.user.teamRole) {
      return (
        <li>
          <i className="fa fa-fw fa-users" />
          {this.props.user.teamRole}
        </li>
      );
    }

    return null;
  };

  renderCurrentAchievements = () => {
    if (this.props.user.currentAchievements) {
      return this.props.user.currentAchievements.map((achievement, i) => {
        return (
          <li key={i}>
            <i className="fa fa-fw fa-trophy" />
            <a href={achievement.url}>{achievement.headline}</a>
          </li>
        );
      });
    }

    return null;
  };

  renderGiveButton = () => {
    return (
      <div className="give-button">
        <a
          className="btn btn-primary btn-small btn-block"
          href={this.props.user.giveUrl}
        >
          {i18n.translate("user.profile_bar.give_a_bonus", {
            user_name: this.props.user.name,
          })}
        </a>
      </div>
    );
  };
}
